module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer__content"
  }, [_vm._l((_vm.displayValue), function(contact, i) {
    return _c('toggle-card', {
      key: i,
      attrs: {
        "heading": _vm.getHeading(contact),
        "can-delete": true,
        "visibility": contact.visibility
      },
      on: {
        "delete": function($event) {
          _vm.onDelete(contact, i)
        }
      }
    }, [_c('z-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": "Имя",
        "required": true,
        "name": ('contact_name-' + i),
        "id": ('contact_name-' + i),
        "data-vv-name": ('contact_name-' + i),
        "data-vv-scope": ('contact-' + i),
        "error": _vm.errors.first(('contact-' + i + '.contact_name-' + i)),
        "data-vv-as": " "
      },
      model: {
        value: (contact.name),
        callback: function($$v) {
          _vm.$set(contact, "name", $$v)
        },
        expression: "contact.name"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('z-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          regex: _vm.phoneValidate
        }),
        expression: "{ required: true, regex: phoneValidate }"
      }],
      staticClass: "col-6",
      attrs: {
        "label": "Телефон",
        "mask": '+7 (999) 999-99-99',
        "required": true,
        "name": ('contact_phone-' + i),
        "id": ('contact_phone-' + i),
        "data-vv-name": ('contact_phone-' + i),
        "data-vv-scope": ('contact-' + i),
        "error": _vm.errors.first(('contact-' + i + '.contact_phone-' + i)),
        "data-vv-as": " "
      },
      model: {
        value: (contact.phone),
        callback: function($$v) {
          _vm.$set(contact, "phone", $$v)
        },
        expression: "contact.phone"
      }
    }), _vm._v(" "), _c('z-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          email: true
        }),
        expression: "{required: true, email: true}"
      }],
      staticClass: "col-6",
      attrs: {
        "label": "E-Mail",
        "type": "email",
        "required": true,
        "name": ('contact_email-' + i),
        "id": ('contact_email-' + i),
        "data-vv-name": ('contact_email-' + i),
        "data-vv-scope": ('contact-' + i),
        "error": _vm.errors.first(('contact-' + i + '.contact_email-' + i)),
        "data-vv-as": " "
      },
      model: {
        value: (contact.email),
        callback: function($$v) {
          _vm.$set(contact, "email", $$v)
        },
        expression: "contact.email"
      }
    })], 1), _vm._v(" "), _c('z-button', {
      staticClass: "md-primary md-dense",
      attrs: {
        "fit-content": "",
        "no-margin": ""
      },
      on: {
        "click": function($event) {
          _vm.saveContact(contact, i, ('contact-' + i))
        }
      }
    }, [_vm._v("Сохранить")])], 1)
  }), _vm._v(" "), _c('z-button', {
    attrs: {
      "fit-content": "",
      "no-margin": ""
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("Добавить контакт")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a01170de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/components/CustomerContacts.vue
// module id = 1231
// module chunks = 0